// The one shared "Condition" rule language (spec §9.1).
//
// A single recursive boolean expression over profile "facts" (a flat
// Record<string,string> map). It is reused, unchanged, in four places:
//   1. Variant `match`        — which version a child gets.
//   2. Card `visible_when`    — whether a block/step shows.
//   3. Field `visible_when`   — whether a guardian form field appears.
//   4. Field `required_when`  — whether a field is required.
//
// The leaf is the original single-comparison shape (formerly
// `VisibleWhenExpression`), so every existing flat `visible_when` value is a
// valid `RuleNode` with no data migration.
// Narrowing helpers — shared by the TS evaluator, the admin rule-builder, and
// any other consumer. Kept here (next to the types) so there is one source of
// truth for how a node's kind is detected.
export function isRuleAll(node) {
    return node.all !== undefined;
}
export function isRuleAny(node) {
    return node.any !== undefined;
}
export function isRuleNot(node) {
    return node.not !== undefined;
}
export function isRuleLeaf(node) {
    return node.variable !== undefined;
}
